import type { DonationFormValues } from '@/donationForm/types'
import { withValues } from '@/form/ActionForm/useActionFormValues/useActionFormValues'
const useDonationFormValues = withValues<DonationFormValues>()
export default useDonationFormValues
